<template>
    <div class="widget-component widget-component-search" v-resize:debounce="onResize">
        <v-container fluid class="widget-search container-width">
            <div id="top"></div>
            <v-progress-linear
                :active="loading"
                :indeterminate="loading"
                absolute
                top
                color="primary"
            ></v-progress-linear>
            <v-overlay :value="loading">
                <v-progress-circular
                    indeterminate
                    size="64"
                    color="primary"
                ></v-progress-circular>
            </v-overlay>
            <v-container fluid class="container-width">
                <!-- Begin Body -->
                <v-row id="main-body">
                    <v-col cols="12" md="4">
                        <search-filters
                            :key="filterUpdateKey"
                            :is-mobile="tablet"
                            :overlay="overlayFilters"
                            :panel="panel"
                            :development-facets="facets"
                            :sort="filters.sort_by"
                            :sort-options="sortOptions"
                            :pagination="pagination"
                            :search-filters="filters"
                            :filter-options="filterOptions"
                            :map="map"
                            :rectBounds="rectBounds"
                            :center="center"
                            @updateFilters="updateFilters"
                            @filtersReady="fetchDevelopments"
                            @togglePanel="togglePanel()"
                        >
                        </search-filters>
                    </v-col>


                    <!-- Begin Search Results -->
                    <v-col cols="12" md="8" class="py-md-8">
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-row>
                                    <!-- <v-col v-if="mobile">
                                        <a @click="togglePanel()">
                                            <strong class="grey--text text--darken-4">{{
                                                    panel !== null ? 'Less' : 'More'
                                                }} filters</strong>
                                            <font-awesome-icon icon="fa-solid fa-sliders" class="pl-1"
                                                               v-if="panel !== 0"/>
                                            <font-awesome-icon icon="fa-solid fa-xmark" class="pl-1" v-else/>
                                        </a>
                                    </v-col> -->

                                    <v-col>
                                        <v-layout>
                                            <v-switch
                                                v-if="showMapSwitcher()"
                                                v-model="map.visible"
                                                inset
                                                label="Map view"
                                                class="mt-0 mt-lg-3"
                                                :class="mobile ? 'float-right' : ''"
                                            ></v-switch>
                                        </v-layout>
                                    </v-col>

                                    <v-col cols="12" sm="6" lg="4" v-if="!map.visible && !tablet">
                                        <v-select
                                            v-model="filters.sort_by"
                                            label="Sort by"
                                            :items="sortOptions"
                                            outlined
                                            class="no-border-radius z-index-15"
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row v-if="showMap && onMapListings.length > 0">
                                    <v-col class="map-container">
                                        <gmap-map
                                            ref="resultsMap"
                                            :options="map.mapDefaults"
                                            class="mb-10"
                                            :center="map.center"
                                        >
                                            <gmap-custom-marker :options="{ 'devid' : listing.id }"
                                                                @click.native="showListing(listing.id)"
                                                                :key="listing.id"
                                                                v-for="(listing) in onMapListings"
                                                                :marker="{lat: listing.latitude, lng: listing.longitude}">
                                                <svg width="28"
                                                     height="39"
                                                     style="cursor: pointer"
                                                     viewBox="0 0 28 39" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M28 14C28 21.732 14 38.5 14 38.5C14 38.5 0 21.732 0 14C0 6.26802 6.26801 8.57217e-06 14 8.57217e-06C21.732 8.57217e-06 28 6.26802 28 14Z"
                                                        :fill="markerIcon(listing)"/>
                                                    <circle cx="14" cy="14.8413" r="6" fill="white"/>
                                                </svg>
                                            </gmap-custom-marker>
                                        </gmap-map>

                                        <listing-card
                                            v-if="selectedDevelopment"
                                            ref="mapListingCard"
                                            :landscape="true"
                                            :show-link-to-listing="true"
                                            :link-to-listing="listingUrl(selectedDevelopment)"
                                            :listing="selectedDevelopment"
                                            :options="listingCardOptions"></listing-card>
                                    </v-col>
                                </v-row>
                                <v-row v-else-if="listings.length > 0">
                                    <v-col cols="12" :key="index"
                                           v-for="(listing, index) in listings">
                                        <listing-card
                                            :show-link-to-listing="true"
                                            :link-to-listing="listingUrl(listing)"
                                            :listing="listing"
                                            :options="listingCardOptions"></listing-card>
                                    </v-col>
                                </v-row>
                                <v-row v-cloak v-else-if="listings.length == 0 && !loading">
                                    <v-col cols="12">
                                        <div class="text-center py-12">
                                            <v-card
                                                class="pa-8"
                                                elevation="0"
                                                outlined

                                            >
                                                <h2>We didn't find any properties that match your criteria</h2>
                                                <p>Try increasing your search area or changing your search
                                                    criteria to get
                                                    more results</p>
                                                <v-btn
                                                    color="primary"
                                                    class="py-4 py-lg-6 px-lg-6 my-6"
                                                    @click="increaseArea()"
                                                    v-if="filters.radius < 50"
                                                    max-width="100%"
                                                    wrap
                                                    :small="mobile"
                                                    :block="mobile"
                                                >
                                                    {{ increaseAreaText }}
                                                </v-btn>
                                            </v-card>
                                        </div>


                                    </v-col>
                                </v-row>
                                <v-row v-if="pagination && pagination.total > 0 && !map.visible">
                                    <v-col cols="12" class="text-center pagination-container">
                                        <v-pagination
                                            v-model="pagination.currentPage"
                                            :length="pagination.lastPage"
                                            :total-visible="7"
                                            @input="handlePagination"
                                        ></v-pagination>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
    </div>
</template>

<script>
import {
    defineComponent,
    ref,
    onMounted,
    nextTick,
    watch,
    computed
} from "@vue/composition-api";
import axios from "../axios";
import ListingCard from "./ListingCard.vue";
import SearchFilters from "./partials/SearchFilters.vue";
import GmapCustomMarker from '@busability/vue2-gmap-custom-marker';
import {gmapApi} from 'vue2-google-maps';
import {find, toNumber, isArray, forEach, map, join, isNil, merge, has, cloneDeep} from "lodash";
import MainMenu from "./partials/MainMenu.vue";
import updatePath from '../composables/updatePath';
import getParams from '../composables/getParams';
import isMobile from '../composables/isMobile';
import isTablet from '../composables/isTablet';
import flushQueue from '../composables/flushQueue';

export default defineComponent({
    name: "Search",
    components: {SearchFilters, ListingCard, MainMenu, GmapCustomMarker},
    props: {
        rootUrl: {
            type: String,
            required: true
        },
        accessToken: {
            type: String,
        },
        listingsUrl: {
            type: String,
            default: null
        },
        options: {
            type: Object
        }
    },
    setup(props, context) {
        const mobile = ref(false);
        const tablet = ref(false);
        const loginDialog = ref(false);
        const token = ref(null);
        const loggedInProfile = ref(null);
        const loading = ref(true);
        const overlayFilters = ref(false);
        const center = ref(null);
        const rectBounds = ref(null);
        const links = ref(null);
        const listings = ref([]);
        const mapListings = ref([]);
        const queriedListings = ref([]);
        const location = ref("");
        const panel = ref(null);
        const filters = ref({
            location: "",
            radius: 3,
            facets: {},
            occupancy_type: "for-sale",
            sort_by: "nearest"
        });

        const defaultFilterOptions = ref({
            filters: {

            },
            sortBy: "new-homes",
            map: {
                show: true,
                markers: {
                    colours: {
                        default: window.lightColors.primary,
                        selected: window.lightColors.secondary,
                    }
                }
            }
        });

        const defaultListingCardOptions = ref({
            landscape: true,
            quantityIcons: false,
            propertyTypeIcons: true,
            iconLibrary: 'fontawesome',
            stats: {
                bedrooms: {shown: true},
                bathrooms: {shown: true},
                deposit: {shown: true},
                sharePercentage: {shown: false},
                share: {shown: true},
                price: {shown: true, label: 'Full market value'},
                rent: {shown: true}
            }
        });

        const filterOptions = computed(() => {
            let optionsClone = cloneDeep(props.options);
            if(has(optionsClone, 'listingCardOptions')) {
                delete optionsClone['listingCardOptions'];
            }
            return merge(defaultFilterOptions.value, optionsClone);
        });

        const showMap = computed(() => {
            if(map.value.visible) {
                if(has(filterOptions.value, 'map.show')) {
                    if(filterOptions.value.map.show === true) {
                        return true;
                    }
                } else {
                    return false;
                }
            }
            return false;
        });

        const facets = ref([]);
        const pagination = ref([]);
        const sortOptions = ref([]);
        const radiusOptions = ref([
            {
                text: "+3 miles",
                value: 3
            },
            {
                text: "+5 miles",
                value: 5
            },
            {
                text: "+10 miles",
                value: 10
            },
            {
                text: "+15 miles",
                value: 15
            },
            {
                text: "+25 miles",
                value: 25
            },
            {
                text: "+40 miles",
                value: 40
            },
            {
                text: "+50 miles",
                value: 50
            }
        ]);

        const menuModels = ref({
            radiusMenu: false,
            maxFullValueMenu: false,
            bedroomsMenu: false,
            forSaleToRentMenu: false,
            moreMenu: false,
            maxMonthlyRentMenu: false
        });

        const listingCardOptions = computed(() => {
            if(has(props, 'options.listingCardOptions')) {
                return merge(defaultListingCardOptions.value, props.options.listingCardOptions);
            }
            return defaultListingCardOptions.value;
        });

        const resultsMap = ref(null);
        const selectedDevelopment = ref(null);
        const mapListingCard = ref(null);
        const filterUpdateKey = ref(0);
        const map = ref({
            visible: false,
            center: {lat: 51.4020695, lng: -0.3007564},
            rectBounds: {north: 0, east: 0, south: 0, west: 0},
            markers: [],
            places: [],
            currentPlace: {},
            rectOptions: {
                strokeColor: '#E05860',
                strokeOpacity: 0.4,
                strokeWeight: 2,
                fillColor: '#FFFFFF',
                fillOpacity: 0.1
            },
            mapDefaults: {
                "zoom": 10,
                "map-type-id": "terrain",
                "streetViewControl": false,
                "mapTypeControl": false,
                "fullscreenControl": false,
                "styles": [
                    {
                        "featureType": "administrative.country",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            },
                            {
                                "hue": "#ff0000"
                            }
                        ]
                    }
                ]
            },
            currentMidx: null,
        });

        watch(() => map.value.visible, (currentValue, oldValue) => {
            if (currentValue === true && listings.value.length > 0) {
                updateMap();
            }
        }, {deep: true});

        watch(() => filters.value.sort_by, (newValue, oldValue) => {
            updatePath(context.root.$router, filters, false, rectBounds.value, center.value);
            fetchDevelopments();
        }, {deep: true});

        watch(() => listings.value, (newValue, oldValue) => {
            loading.value = false;
        });

        const google = computed(() => {
            return gmapApi
        });

        const onMapListings = computed(() => {
            if(mapListings.value.length) {
                return mapListings.value;
            }
            return listings.value;
        });

        const increaseAreaText = computed(() => {
            let text = "Widen search (+";
            let currentRadius = filters.value.radius;
            let findCurrentChoice = _.findIndex(radiusOptions.value, {
                value: currentRadius
            });
            let nextIndex = null;
            if (findCurrentChoice >= 0) {
                nextIndex = findCurrentChoice + 1;
                if (radiusOptions.value[nextIndex]) {
                    text +=
                        radiusOptions.value[nextIndex].value -
                        radiusOptions.value[findCurrentChoice].value;
                }
            }
            text += " miles)";
            return text;
        });

        function togglePanel() {
            if (panel.value !== null) {
                panel.value = null;
                scrollToTop();
            } else {
                panel.value = 0;
            }
        }

        function updateFilters(value) {
            filters.value = value;
        }

        function fetchDevelopments(resetCoordinates = false) {
            loading.value = true;
            let parameters = getParams(filters, resetCoordinates, rectBounds.value, center.value);
            axios
                .get("search", {
                    params: parameters
                })
                .then(function (response) {
                    if (response.data.data) {
                        listings.value = response.data.data;
                        // By default we make the first listing selected
                        //selectedDevelopment.value = listings.value[0];

                        // And we add the listings into the queriedListingsArray if
                        // they're not already there.
                        forEach(listings.value, function(lst) {
                            if(!find(queriedListings.value, {id: lst.id})) {
                                queriedListings.value.push(lst);
                            }
                        });
                    }

                    if (response.data.facets) {
                        facets.value = response.data.facets;
                    }

                    if (response.data.pagination) {
                        pagination.value = response.data.pagination;
                        if (pagination.value.currentPage > pagination.value.lastPage) {
                            filters.value.page = 1;
                            updatePath(context.root.$router, filters, resetCoordinates, rectBounds.value, center.value);
                            fetchDevelopments();
                        }
                    }
                    if (response.data.sortOptions) {
                        normalizeSortOptions(response.data.sortOptions);
                        if (!context.root.$route.query.sort_by) {
                            if (response.data.sortOptions[0]) {
                                context.root.$router.replace({
                                    query: Object.assign(
                                        {...context.root.$route.query},
                                        {sort_by: props.options.sortBy}
                                    )
                                });
                                filters.value.sort_by = props.options.sortBy;
                            }
                        } else {
                            filters.value.sort_by = context.root.$route.query.sort_by;
                        }
                    }
                    if (response.data.center) {
                        center.value = response.data.center;
                    }
                    if (response.data.rectBounds) {
                        rectBounds.value = response.data.rectBounds;
                    }
                    if (response.data.links) {
                        links.value = response.data.links;
                    }
                    if (response.data.mapListings) {
                        mapListings.value = response.data.mapListings;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    if (showMap.value) {
                        fitBounds();
                    }
                });
        }

        function handlePagination(page) {
            filters.value.page = page;
            updatePath(context.root.$router, filters, false, rectBounds.value, center.value);
            fetchDevelopments();
            scrollToTop();
        }

        function listingUrl(listing) {
            let listingSlug = listing.slug;
            if(has(listing, 'widgetSiteSettings.customSlug')) {
                if(listing.widgetSiteSettings.customSlug) {
                    listingSlug = listing.widgetSiteSettings.customSlug;
                }
            }
            if (props.listingsUrl) {
                return props.listingsUrl.replace("{slug}", listingSlug);
            } else {
                let urlFilters = "";
                if (filters.value.facets.bedrooms.length > 0) {
                    urlFilters += "?bedrooms=";
                    urlFilters += _.join(filters.value.facets.bedrooms, "&bedrooms=");
                }
                return props.rootUrl + "/listing/" + listingSlug + urlFilters;
            }
        }

        function normalizeSortOptions(options) {
            if(has(props, 'options.sortOptions')) {
                const sortOps = [];
                forEach(props.options.sortOptions, function(opt) {
                    if(find(options, { 'value': opt.value })) {
                        sortOps.push(opt);
                    }
                });
                sortOptions.value = sortOps;
            } else {
                sortOptions.value = options;
            }
        }

        function updateMap() {
            loading.value = true;
            if (listings.value.length > 0 && map.value.visible) {
                nextTick(() => {
                    fitBounds();
                    loading.value = false;
                });
            }
        }

        function showListing(listingId) {
            //mapListingCard.value.$el.style.opacity = 0
            //mapListingCard.value.$el.style.transform = 'translateY(20px)';

            // We search the listing by its id inside our queriedListings array
            // because if it's there we don't have to do an another ajax call, to get the listing results
            let listingInQueriedListingsArray = find(queriedListings.value, {id:listingId});
            // If found we make it selected
            if(listingInQueriedListingsArray) {
                selectedDevelopment.value = listingInQueriedListingsArray;
                setTimeout(() => {
                    mapListingCard.value.$el.style.opacity = 1
                    mapListingCard.value.$el.style.transform = 'translateY(0px)';
                }, 300)
            } else {
                // If not, we're doing an ajax call and get the listing details.
                axios
                    .get("listings/" + listingId)
                    .then(function (response) {
                        if (response.data) {
                            selectedDevelopment.value = response.data;
                            queriedListings.value.push(response.data);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                        setTimeout(() => {
                            mapListingCard.value.$el.style.opacity = 1
                            mapListingCard.value.$el.style.transform = 'translateY(0px)';
                        }, 300)
                    });

            }
        }

        function markerIcon(listing) {
            if(has(selectedDevelopment, 'value.id') && has(listing, 'id')) {
                if(selectedDevelopment.value.id === listing.id) {
                    if (has(filterOptions.value, 'map.markers.colours.selected')) {
                        return filterOptions.value.map.markers.colours.selected;
                    } else {
                        return window.lightColors.secondary;
                    }
                }
            }

            if (has(filterOptions.value, 'map.markers.colours.default')) {
                return filterOptions.value.map.markers.colours.default;
            } else {
                return window.lightColors.primary;
            }
        }

        function fitBounds() {
            resultsMap.value.$mapPromise.then((map) => {
                const googleApi = new google.value().maps;
                let bounds = new googleApi.LatLngBounds();
                listings.value.map(function (value, key) {
                    bounds.extend(new googleApi.LatLng({lat: value.latitude, lng: value.longitude}));
                });
                resultsMap.value.fitBounds(bounds);
                var boundsListener = googleApi.event.addListener(map, "idle", function () {
                    if (map.getZoom() > 16) {
                        map.setZoom(16);
                    }
                    googleApi.event.removeListener(boundsListener);
                });
            });
        }

        function increaseArea() {
            let addMoreRadius = 0;
            let currentRadius = filters.value.radius;
            let findCurrentChoice = _.findIndex(radiusOptions.value, {
                value: currentRadius
            });
            let nextIndex = null;
            if (findCurrentChoice >= 0) {
                nextIndex = findCurrentChoice + 1;
                if (radiusOptions.value[nextIndex]) {
                    addMoreRadius +=
                        radiusOptions.value[nextIndex].value -
                        radiusOptions.value[findCurrentChoice].value;
                }
            }
            if (addMoreRadius > 0) {
                filters.value.radius = filters.value.radius + addMoreRadius;
            }
        }

        function scrollToTop() {
            document.getElementById("top").scrollIntoView({behavior: "smooth"});
        }

        function handleLoginEmit() {
            if (data.loggedInProfile) {
                loggedInProfile.value = data.loggedInProfile;
            }
            if (data.accessToken) {
                token.value = data.accessToken;
            }
        }

        function handleLoginDialogEmit(val) {
            loginDialog.value = val;
        }

        function onResize() {
            if (!isMobile()) {
                mobile.value = false;
            } else {
                mobile.value = true;
            }

            if (!isTablet()) {
                panel.value = 0;
                tablet.value = false;
            } else {
                tablet.value = true;
            }
        }

        function showMapSwitcher() {
            if (has(filterOptions.value, 'map.show')) {
                return filterOptions.value.map.show;
            } else {
                return false;
            }
        }

        onMounted(() => {
            flushQueue().then(() => {
                onResize();
                if (!isTablet()) {
                    panel.value = 0;
                } else {
                    panel.value = null;
                }

                if (overlayFilters.value) {
                    const offset = document.getElementById('sidebar').offsetHeight;
                    document.getElementById('main-body').style.paddingTop = offset + 'px';
                }
            })
        })

        return {
            loading,
            overlayFilters,
            center,
            rectBounds,
            links,
            listings,
            mapListings,
            onMapListings,
            location,
            sortOptions,
            radiusOptions,
            panel,
            togglePanel,
            filters,
            filterOptions,
            facets,
            pagination,
            menuModels,
            updateFilters,
            fetchDevelopments,
            selectedDevelopment,
            mapListingCard,
            markerIcon,
            map,
            GmapCustomMarker,
            resultsMap,
            showListing,
            increaseAreaText,
            loginDialog,
            listingUrl,
            handlePagination,
            increaseArea,
            handleLoginDialogEmit,
            handleLoginEmit,
            listingCardOptions,
            filterUpdateKey,
            mobile,
            tablet,
            onResize,
            defaultFilterOptions,
            find,
            showMapSwitcher,
            has,
            showMap,
            queriedListings
        };
    }
});
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.widget-search {
    @media #{map-get($display-breakpoints, 'md-and-down')}{
        overflow: hidden;
    }

    .pagination-container {
        .v-pagination__item,
        .v-pagination__navigation {
            border-radius: 0;
            font-weight: 600;
            box-shadow: none;
            background-color: #f5f4f1;
        }
    }

    .no-border-radius .v-input__slot {
        border-radius: 0;
    }

    .z-index-15 {
        z-index: 15;
    }

    .sortBySelect {
        z-index: 15;
    }

    .moreMenu {
        z-index: 15;
    }

    .vue-map-container {
        height: 672px;

        @media #{map-get($display-breakpoints, 'xs-only')}{
            height: 520px;
        }
    }
}
</style>
